import { SalaryAdvancePhase } from "@tymbe/legislatives/SalaryAdvancePhase";

export const salaryAdvancePhaseNameMap: Record<SalaryAdvancePhase, string> = {
  [SalaryAdvancePhase.Authorized]: 'Přiznané',
  [SalaryAdvancePhase.Paid]: 'Vyplacené',
}
